var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_302_919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.9532 0C17.5772 0 8.35418 9.22297 8.35418 20.599C8.35418 25.2221 9.89642 29.4762 12.4686 32.9136L0.447754 44.9344L5.51331 50L17.6828 37.8305C20.9231 39.9531 24.7904 41.198 28.9532 41.198C40.3292 41.198 49.5521 31.975 49.5521 20.599C49.5521 9.22297 40.3292 0 28.9532 0ZM28.9532 35.8243C20.5577 35.8243 13.7278 28.9944 13.7278 20.599C13.7278 12.2036 20.5577 5.37365 28.9532 5.37365C37.3486 5.37365 44.1785 12.2036 44.1785 20.599C44.1785 28.9944 37.3486 35.8243 28.9532 35.8243Z",
    fill: "#7DC370"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.4752 17.0166H19.1016V29.5551H24.4752V17.0166Z",
    fill: "#7DC370"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.6402 9.85168H26.2666V29.5551H31.6402V9.85168Z",
    fill: "#7DC370"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.805 13.4341H33.4314V29.555H38.805V13.4341Z",
    fill: "#7DC370"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.338632ab9a2a0cd4e071c0d629018511.svg";
export { ForwardRef as ReactComponent };